import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials=true lets httpOnly auth cookies flow with every request
export const api = axios.create({ baseURL: API, withCredentials: true });

export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { "X-Admin-Token": token },
  });

/** Render FastAPI 422 arrays / dicts safely as a string. */
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
